export default __webpack_public_path__ + "static/media/Instagram.d1b3c067.svg";